import { rangeToAPI, selectedProductsToAPI } from '@sm/api';
import { GLOBAL_MK } from '@sm/Flags';
import { setSelectedProducts } from '../store/actions';

// eslint-disable-next-line import/prefer-default-export
export const buildParams = ({ state, dispatch }, skipSelectedProducts, useCompareRange = false) => {
  const { dateRange, marketplaceID, compareDateRange, selectedSalesChannels } = state.selector;
  const dateRangeToAPI = rangeToAPI(useCompareRange ? compareDateRange : dateRange);

  let result = {
    ...dateRangeToAPI,
    marketplaceID,
    sales_channels: selectedSalesChannels.join(',')
  };
  if (marketplaceID === GLOBAL_MK) result.currency = state.user.profile.defaultSettings?.currency;
  const addSelectedProductsParams = () => {
    const {
      selectedProducts,
      selectedBookmark,
      tempBookmark,
      isPersistBookmark
    } = state.productSearch;
    if (!selectedProducts.length) return;
    if (isPersistBookmark) {
      result.bookmark_id = selectedBookmark?.id;
    } else if (tempBookmark?.id) {
      const tempBookmarkExpired = tempBookmark?.expiry_date < Date.now();
      if (tempBookmarkExpired) {
        if (dispatch) dispatch(setSelectedProducts([...selectedProducts]));
        result.temp_bookmark_expired = true;
        return;
      }
      result.bookmark_id = tempBookmark?.id;
    } else {
      result = { ...result, ...selectedProductsToAPI(selectedProducts) };
    }
  };
  if (!skipSelectedProducts) addSelectedProductsParams();
  return result;
};

export const buildParamsCompare = (state, dispatch, skipSelectedProducts = false) => {
  const params = buildParams({ state, dispatch }, skipSelectedProducts);
  const compareRange = state.selector.compareDateRange;
  const compareParams = compareRange
    ? buildParams({ state, dispatch }, skipSelectedProducts, true)
    : null;
  return { params, compareParams };
};
